import { render } from "./toast.vue?vue&type=template&id=86d2aa1a"
const script = {}

import "./toast.vue?vue&type=style&index=0&id=86d2aa1a&lang=less"

import exportComponent from "/Users/imp/work/sathikash_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__